module.exports = __webpack_public_path__ + "img/auto-locate.3e8202f9.svg";